import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/front/6_dogs-2/6_dogs-2"
 * Contains 6 texture(s)
 */
export class CardsFront6Dogs2Atlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/front/6_dogs-2/6_dogs-2';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        'ace-spades.png',
        'ace-hearts.png',
        'ace-diamonds.png',
        'ace-clubs.png',
        '9-spades.png',
        '9-hearts.png'
    ] as const;
}
